import Api from '@/api'
const resource = 'accounts'

export default {
  delete (id) {
    return Api.delete(`/${resource}/${id}`)
  },

  synchronize (accountId) {
    return Api.post(`/${resource}/${accountId}/synchronize`)
  }
}
